import React from 'react'
import {Toolbar} from 'react-onsenui';

// eslint-disable-next-line import/no-anonymous-default-export
export default ({left, right}) => <Toolbar style={{boxShadow: "0 5px 6px -6px #888888", position: "unset"}}>
    <div className='left' style={{display: "none"}}/>
    <div className='center' style={{display: "none"}}/>
    <div className='right' style={{display: "none"}}/>
    <div className="flex-space-between"
         style={{alignItems: "center", height: "100%", width: "100%", padding: "0 10px 0 10px"}}>
        <div>{left}</div>
        <div>{right}</div>
    </div>
</Toolbar>